import { ReactNode } from 'react';
import styled from 'styled-components';
import { body2, body2Bold, colors } from 'ui/theme';

const Message = styled.div`
  & > div {
    ${body2};
    color: ${colors.white};
  }
`;

const Name = styled.span`
  ${body2Bold};
  color: ${colors.white};
`;

export type ToastMessageProps = {
  prefix?: string;
  name?: string;
  suffix?: string;
  children?: ReactNode;
};

export const ToastMessage = ({ name, suffix, prefix, children }: ToastMessageProps) => (
  <Message>
    <div>
      {prefix && prefix}
      {name && <Name data-test="toast-message-name">{name}</Name>}
      {suffix && suffix}
    </div>
    {children && <div>{children}</div>}
  </Message>
);
